import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://auria.ai";

const PAGE_PATHS: Record<string, { es: string; en: string }> = {
  "/": { es: "/", en: "/?lang=en" },
  "/blog": { es: "/blog", en: "/blog?lang=en" },
  "/sobre-nosotros": { es: "/sobre-nosotros", en: "/sobre-nosotros?lang=en" },
  "/roadmap": { es: "/roadmap", en: "/roadmap?lang=en" },
  "/privacidad": { es: "/privacidad", en: "/privacidad?lang=en" },
  "/terminos": { es: "/terminos", en: "/terminos?lang=en" },
  "/cuenta": { es: "/cuenta", en: "/cuenta?lang=en" },
};

export default function HreflangHead() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;

    // Remove previously injected dynamic hreflang tags
    document.querySelectorAll('link[data-dynamic-hreflang="true"]').forEach((el) => el.remove());

    const paths = PAGE_PATHS[pathname];
    if (!paths) return;

    const canonical = document.querySelector('link[rel="canonical"]');

    const tags = [
      { hreflang: "es", href: `${BASE_URL}${paths.es}` },
      { hreflang: "en", href: `${BASE_URL}${paths.en}` },
      { hreflang: "x-default", href: `${BASE_URL}${paths.es}` },
    ];

    tags.forEach(({ hreflang, href }) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.setAttribute("hreflang", hreflang);
      link.href = href;
      link.setAttribute("data-dynamic-hreflang", "true");
      if (canonical) {
        canonical.after(link);
      } else {
        document.head.appendChild(link);
      }
    });

    // Update canonical too
    if (canonical) {
      (canonical as HTMLLinkElement).href = `${BASE_URL}${pathname}`;
    }

    return () => {
      document.querySelectorAll('link[data-dynamic-hreflang="true"]').forEach((el) => el.remove());
    };
  }, [location.pathname]);

  return null;
}
